<template>
	<div id="ImgIntroduction">
		<div style="min-height: 353px;">
			<div class="ImgIntroduction" v-dompurify-html="content" v-if="have">
			{{content}}
		</div>
        <div v-else class="nothing">
            <img :src="imgPath+'nothing.png'" alt="暂无数据">
        </div>
		<div class="loading" v-show="loading"><van-loading color="black"/></div>
		</div>
		<div class="zizhilist" v-if="xianshilist == '2'">
			<div class="lianghezi">
                <div @click="tiaozhuangxin" class="xinxi">
					<p>公司信息</p>
				</div>
				<!-- <div @click="tiaozhuangzhongxin" class="zhongxin">
					<p>个人中心</p>
				</div> -->
			</div>
			<div class="jishuzhichi">
				<p>腾慧云直播提供技术支持</p>
			</div>
			<div class="tiaoguanw">
				<a href="https://www.tenghuiwangxiao.cn/">www.tenghuiwangxiao.cn</a>
			</div>
		</div>
	</div>
</template>
<script>
    import qs from "qs";
	import { Toast } from 'vant';
	import tool from '../../../kits/Tools.js';
	import Vue from 'vue';
	import { Loading } from 'vant';
	Vue.use(Loading);

	export default {
		data() {
			return {
				content:'',
				loading:true,
				have:true,
				loaded:false,
				imgPath:'',
				xianshilist: ''
			}
		},
		props:['mid','currentMid','uid','fans_id'],
		created() {
			this.xianshiyingc()
		},
		mounted(){
			this.imgPath = tool.imgPath();
		},
		watch:{
			currentMid(){
				if(!this.loaded && this.currentMid == this.mid){
					this.getData();
				}
			}
		},
		methods: {
			xianshiyingc() {
				var that = this;
				this.axios.post(tool.baseUrl1()+'/api/store_msg', qs.stringify({ uid: this.uid }))
				.then(function(data){
					Toast.clear();
			        if(data.data.code == "200") {
						that.xianshilist = data.data.data.is_show
			        }
			    })
			},
			tiaozhuangxin() {
				this.$router.push({'path':'/Companyinformation', query: {uid:this.uid}});
			},
			tiaozhuangzhongxin() {
				this.$router.push({'path':'/MyPage', query: {uid:this.uid, fans_id: this.fans_id}});
			},
			getData() {
				var that = this;
				var option = 'ds_id='+tool.getQueryDsId()+'&mid='+this.mid;
				Toast.loading({
					mask: true,
					message: '加载中...'
				});
				this.axios.post(tool.baseUrl3()+'/index/picText',option).then(function(data){
					console.log(data.data)
					that.loading = false;
					Toast.clear();
	                if(data.data.code == "200") {
						if(!data.data.data.content){
							that.have = false;
							return false;
						}else{
							that.content = data.data.data.content;
						}
						that.loaded = true;
					} else {
						Toast("获取介绍失败");
					}
            	}).catch(function(){
				//Toast("获取介绍失败");
            	})
			}
		}
	}
</script>

<style>
.zizhilist {
	background: rgb(250, 250, 250);
	margin-top: 20px;
	height: 110px;
}
.lianghezi {
	width: 100px;
	height: 30px;
	margin: 0 auto;
	display: flex;
	padding-top: 10px;
}
.xinxi {
	width: 100px;
	text-align: center;
	line-height: 30px;
	/* border-left: 1px solid #000;
	border-right: 1px solid #000; */
}
.xinxi p {
	color: rgb(100, 100, 100);
	font-size: 13px;
}
.zhongxin {
	width: 100px;
	text-align: center;
	line-height: 30px;
	border-right: 1px solid #000;
}
.zhongxin p {
	color: rgb(100, 100, 100);
}
.jishuzhichi {
	margin-top: 10px;
	text-align: center;
}
.jishuzhichi p {
    color: rgb(140, 140, 140);
	font-size: 12px;
}
.tiaoguanw {
	text-align: center;
	margin-top: 10px;
}
.tiaoguanw a {
	color: rgb(140, 140, 140);
	font-size: 12px;
}
.ImgIntroduction .nothing {
	margin-top: 100px;
}

#ImgIntroduction {
	height: 100%;
	overflow-x: auto;
}

.ImgIntroduction {
	padding: 10px;
}

.ImgIntroduction h1,.ImgIntroduction h2,.ImgIntroduction h3,.ImgIntroduction h4,.ImgIntroduction h5,.ImgIntroduction h6 {
	text-align: center;
	padding-bottom: 10px;
}

.ImgIntroduction img {
	max-width: 100%;
	margin: 5px auto;
	display: block;
}

.loading {
	height: 30px;
	width: 30px;
	margin: 10px auto;
}
#ImgIntroduction .ql-align-right{
	text-align: right;
}
#ImgIntroduction .ql-size-huge {
    font-size: 2.5em;
}
#ImgIntroduction .ql-align-center {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// ImgText.vue?326d4e02